<div class="no-active-service">
    <div class="no-active-service__logo">
        <img src="/assets/img/puesc.png" alt="logo puesc">
    </div>
    <div class="no-active-service__no-active">
        <span class="no-active-service__no-active__title">
            {{'labels.inactive'|translate}}
        </span>
    </div>

    <div class="no-active-service__details">
        <span class="no-active-service__details__desc">
            {{'contactWithUsTitle'|translate}} <br> <b>{{ 'contact.phone' | translate }} {{'labels.or'|translate}} </b> <span class="email">{{'contact.email'|translate}}</span>
        </span>
        <!-- <p-button class="no-active-service__details__submit" [label]="'Aktywuj usługę'"></p-button> -->

        <!-- <span class="no-active-service__details__desc contact">

        </span> -->
    </div>
</div>
